import { ManageEntityTags } from "@portal/components/admin/ManageEntityTags";
import { HeaderActions } from "@portal/components/layout/HeaderActions";
import { AdminUserMenu } from "./AdminUserMenu";

export const ManageEntityTagsView = () => {
	return (
		<div className="flex flex-col justify-center items-start w-full">
			<div className="w-full flex items-center justify-end px-[30px] pt-[20px] pb-[22px]">
				<HeaderActions userMenu={<AdminUserMenu />} />
			</div>
			<div className="flex w-full">
				<div className="flex-1" />
				<div className="flex flex-col mt-36 flex-[3]">
					<div className="flex flex-col">
						<span
							data-testid="manage-entity-tags-label"
							className="text-[32px] font-medium text-primary"
						>
							Manage Entity Tags
						</span>
						<div className="mt-8">
							<ManageEntityTags />
						</div>
					</div>
				</div>
				<div className="flex-1" />
			</div>
		</div>
	);
};
